import { render, staticRenderFns } from "./order-state.vue?vue&type=template&id=73fb1e67"
import script from "./order-state.vue?vue&type=script&lang=ts"
export * from "./order-state.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73fb1e67')) {
      api.createRecord('73fb1e67', component.options)
    } else {
      api.reload('73fb1e67', component.options)
    }
    module.hot.accept("./order-state.vue?vue&type=template&id=73fb1e67", function () {
      api.rerender('73fb1e67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/order-state.vue"
export default component.exports